
import { NgModule } from '@angular/core';

import { SupplierEditProvider } from './supplier-edit.provider';
import { SupplierListProvider } from './supplier-list.provider';

export * from './supplier-edit.provider';
export * from './supplier-list.provider';

export {
  SupplierListProvider,
  SupplierEditProvider
};

@NgModule({
  declarations: [

  ],
  imports: [
  ],
  exports: [

  ],
  providers: [
    SupplierEditProvider,
    SupplierListProvider
  ]
})
export class SupplierBackendModule { }
